"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const otp_1 = require("@/app/shared/components/common/input/otp");
const labels_1 = __importDefault(require("@/app/shared/i18n/labels"));
const constants_1 = require("@/app/SUMO/store/user/constants");
const user_1 = require("@/app/SUMO/store/user");
const button_1 = require("primereact/button");
const checkbox_1 = require("primereact/checkbox");
const utils_1 = require("primereact/utils");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const MfaPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isFetching = (0, react_redux_1.useSelector)(user_1.SUMO1UserSelectors.selectMfaIsFetching);
    const mfaError = (0, react_redux_1.useSelector)(user_1.SUMO1UserSelectors.selectMfaError);
    const [mfaOtp, setMfaOtp] = (0, react_1.useState)('');
    const [saveDevice, setSaveDevice] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        return () => {
            dispatch(user_1.SUMO1UserActions.mfaReset());
        };
    }, [dispatch]);
    (0, react_1.useEffect)(() => {
        if (mfaError === constants_1.MfaError.INCORRECT_CODE) {
            setMfaOtp('');
        }
    }, [mfaError]);
    const handleOtpChange = (0, react_1.useCallback)((value) => {
        setMfaOtp(value);
    }, []);
    const handleSubmit = (0, react_1.useCallback)(() => {
        if (mfaOtp.length !== constants_1.OTP_LENGTH)
            return;
        dispatch(user_1.SUMO1UserActions.confirmMfaRequest({ code: mfaOtp, saveDevice }));
    }, [dispatch, mfaOtp, saveDevice]);
    const handleBack = (0, react_1.useCallback)(() => {
        dispatch(user_1.SUMO1UserActions.mfaReset());
        dispatch(user_1.SUMO1UserActions.setLoginStep(user_1.LoginStep.PASSWORD));
        setMfaOtp('');
        setSaveDevice(false);
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-16px', children: [(0, jsx_runtime_1.jsxs)(button_1.Button, { text: true, className: 'p-0 w-fit text-blue-100 text-label-s-med', onClick: handleBack, disabled: isFetching, children: [(0, jsx_runtime_1.jsx)("i", { className: 'pi pi-arrow-left mr-8px' }), labels_1.default.LOGIN_BACK] }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-8px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'text-title-lg-med text-gray-100', children: labels_1.default.MFA_TITLE }), (0, jsx_runtime_1.jsx)("div", { className: 'text-body-lg-reg text-gray-60', children: labels_1.default.MFA_SUBTITLE })] }), (0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-column gap-16px', children: [(0, jsx_runtime_1.jsx)(otp_1.InputOtp, { value: mfaOtp, onChange: handleOtpChange, length: constants_1.OTP_LENGTH, placeholder: '\u00B7', disabled: isFetching, autoFocus: true }), mfaError === constants_1.MfaError.INCORRECT_CODE && ((0, jsx_runtime_1.jsx)("div", { className: 'text-body-s-reg text-red-100', children: labels_1.default.MFA_INCORRECT_CODE })), (0, jsx_runtime_1.jsxs)("div", { className: 'flex-left-center gap-8px', children: [(0, jsx_runtime_1.jsx)(checkbox_1.Checkbox, { checked: saveDevice, onChange: (e) => setSaveDevice(e.checked ?? false), inputId: 'saveThisDevice', disabled: isFetching }), (0, jsx_runtime_1.jsx)("label", { htmlFor: 'saveThisDevice', className: 'text-body-lg-reg text-gray-60 cursor-pointer', children: labels_1.default.MFA_SAVE_THIS_DEVICE })] })] }), (0, jsx_runtime_1.jsx)(button_1.Button, { label: labels_1.default.MFA_VERIFY, className: (0, utils_1.classNames)('w-full h-48px border-round-lg', {
                    'bg-gray-1 text-gray-50 border-gray-1 shadow-none': mfaOtp.length !== constants_1.OTP_LENGTH || isFetching,
                }), disabled: mfaOtp.length !== constants_1.OTP_LENGTH || isFetching, loading: isFetching, onClick: handleSubmit })] }));
};
exports.MfaPage = MfaPage;
